@import (reference) '../../../../constants/spacing.module.less';

.rate-list-item {
  display: flex;
  gap: @space-8;
  padding: @space-8 @space-16 @space-8 @space-8;
  justify-content: space-between;
  border-radius: 4px;
  text-align: start;
  position: relative;

  background: var(--light--background-color--1);
  border: 1px solid var(--default--border-color--10);

  overflow: hidden;

  &.is-selected {
    // Border increases by 1px, so offset margin to avoid items shifting
    margin: -1px;
    background: var(--default--background-color--2);
    border: 2px solid var(--primary--button--selected--border-color--4);

    &:hover {
      background: var(--default--background-color--2);
    }
  }

  &.has-tag {
    padding: @space-24 @space-16 @space-8 @space-8;
  }

  &:hover {
    background: var(--primary--button--hover--background-color--3);
  }
}

.provider-and-service {
  display: flex;
  gap: @space-4;
  flex: 50%;
  overflow: hidden;
}

.provider-logo {
  height: 52px;
  width: 52px;
  padding: @space-8;
}

.service-info {
  display: flex;
  flex-flow: column nowrap;
  overflow: hidden;
}

.rate-name-and-tag {
  display: flex;
  gap: @space-8;
}

.package-and-account {
  color: var(--default--text-color--9);
  display: flex;
  flex-flow: column nowrap;
}

.package-name {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.account-name {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.delivery-time {
  flex: 35%;
  text-align: center;
}

.rate-value {
  flex: 15%;
  text-align: end;
}

.divider {
  border-color: var(--default--border-color--10);
}

.rate-tag {
  display: flex;
  padding: @space-0 @space-8;
  align-items: center;
  gap: @space-8;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 0 0 8px;
  background: var(--blue-11003A);
  color: var(--light--text-color--1);

  &.is-selected {
    background: var(--primary--button--selected--border-color--4);
  }
}
